import { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { isValidJSON } from 'Services/WeaverUtils';
import AceEditor from 'react-ace';
import 'ace-builds/webpack-resolver';
import 'ace-builds/src-noconflict/mode-html';
import 'ace-builds/src-noconflict/mode-json5';
import 'ace-builds/src-noconflict/snippets/html';

const AceInput = ({ darkModeEnabled, extra, value, onChange, mode, ...props }) => {
  const aceEditorRef = useRef(null);
  
  const cleanValue = (v) => {
    if (v === undefined) return '';
    if (typeof v === 'object') return JSON.stringify(v, null, 2);
    if (isValidJSON(v)) return JSON.stringify(JSON.parse(v), null, 2);
    return v;
  };
  
  const [workValue, setWorkValue] = useState(cleanValue(value));
  
  const handleChange = (v) => {
    setWorkValue(v);
    onChange(v);
  };
  
  return (
    <div style={{ borderRadius: '10px', border: 'solid 1px #eee', padding: '2px' }}>
      {extra}
      <AceEditor
        {...props}
        onChange={handleChange}
        ref={aceEditorRef}
        value={workValue}
        style={{ width: '100%', borderRadius: 9 }}
        theme={darkModeEnabled ? 'solarized_dark' : 'solarized_light'}
        showGutter={true}
        mode={mode || 'json'}
        fontSize={14}
        setOptions={{
          highlightActiveLine: false,
          highlightGutterLine: false,
          showLineNumbers: false,
          minLines: 5,
          maxLines: 1000,
          autoScrollEditorIntoView: false,
        }}
      />
    </div>
  );
};

const mapStateToProps = ({ explore }) => ({
  darkModeEnabled: explore.darkModeEnabled,
});

export default connect(mapStateToProps)(AceInput);